import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import LoadingButton from '../../common/LoadingButton';
import { PetCloudInput } from '../../common/petCloud';
import { isEmailValid, removeEmojis } from '../../../services/utils';

import styles from './LandingScreen.module.css';

const LandingScreen = ({
  email = '',
  onSignInClick = () => { },
  setEmail = () => { },
  validateEmail = () => { },
  validatingEmail = false,
}) => {
  const { t } = useTranslation('petDemos');
  const [emailError, setEmailError] = useState('');

  // local email validations before submitting to backend
  const localEmailValidations = useCallback(() => {
    const validEmail = isEmailValid(email);
    let error = '';

    if (!validEmail) {
      error = t('certificateLinking.landing.invalidEmail');
    }

    setEmailError(error);

    return validEmail;
  }, [email, setEmailError, t]);

  const handleSignUp = useCallback((event) => {
    event.preventDefault();

    if (localEmailValidations()) {
      // then validates email in backend side
      validateEmail(email);
    }
  }, [localEmailValidations, validateEmail]);

  const onEmailChange = useCallback((event) => {
    const { target } = event;
    setEmailError('');
    setEmail(removeEmojis(target.value));
  }, [setEmail, setEmailError]);

  const onEmailBlur = useCallback(() => {
    localEmailValidations();
  }, [email, t, localEmailValidations]);

  return (
    <div className={styles.container}>
      <div className={styles.titleContainer}>
        <h1 className={styles.welcomeTitle}>
          {t('certificateLinking.landing.welcomeTitle')}
        </h1>

        <p className={styles.description}>
          {t('certificateLinking.landing.description')}
        </p>
      </div>

      <form className={styles.inputContainer} onSubmit={handleSignUp}>
        <PetCloudInput
          autoComplete="email"
          disabled={validatingEmail}
          error={emailError}
          id="email"
          onBlur={onEmailBlur}
          onChange={onEmailChange}
          placeholder={t('certificateLinking.landing.emailPlaceholder')}
          type="email"
          value={email}
        />

        <LoadingButton
          className={styles.signUpButton}
          disabled={validatingEmail}
          loading={validatingEmail}
          text={t('certificateLinking.landing.signUp')}
        />
      </form>

      <div className={styles.signInRow}>
        <span>{t('certificateLinking.landing.alreadyRegistered')}</span>

        <button
          className={styles.signInLink}
          onClick={onSignInClick}
          type="button"
        >
          {t('certificateLinking.landing.signInHere')}
        </button>
      </div>
    </div>
  );
};

export { LandingScreen };
